import Cookies from 'js-cookie';

import {
  PARTNER_LOGO,
  ACCEPTED_PAYMENT_METHOD,
  PARTNER_CREDIT_VALUES,
  PARTNER_MOBILE_LOGO,
  PARTNER_MACHINES,
  LIDL_COOKIE,
  PARTNERS,
  DIRECT_DEBIT_VERIFICATION_MAX_ATTEMPTS,
  AGENT_JOURNEYS_DIRECT_DEBIT_MAX_ATTEMPTS
} from 'config/app-config';

import { getSessionStoragePartner } from 'utils/getSessionStoragePartner';
import { checkMatchPath } from 'utils/misc';
import { useResponsive } from 'hooks/useResponsive';
import { directSalesMachineConfig } from 'machines/direct-sales-machine';

type AcceptedPaymentMethods = Array<'mdd' | 'qcc' | 'ppm' | 'qvdd'>;

export const usePartner = () => {
  const { isDesktop } = useResponsive();
  const partnerLandingPaths = Object.values(PARTNERS);
  const partnerPath = getSessionStoragePartner();
  const activePartner = partnerLandingPaths.reduce((acc, partner) => {
    return {
      ...acc,
      [partner]: checkMatchPath(partnerPath, partner)
    };
  }, {});

  const isLidl = !!Cookies.get(LIDL_COOKIE);
  const isDSJourney: boolean =
    activePartner[PARTNERS.DIRECT_SALES] ||
    // treat these journey as standard journeyes
    activePartner[PARTNERS.QUOTE_BY_EMAIL] ||
    activePartner[PARTNERS.AWIN] ||
    activePartner[PARTNERS.REFER_A_FRIEND] ||
    activePartner[PARTNERS.ABANDONED_CART] ||
    activePartner[PARTNERS.SECOND_QUOTE] ||
    isLidl;

  const currentPartner = Object.entries(activePartner).filter(
    ([, val]) => !!val
  )[0];

  const partnerName = currentPartner ? currentPartner[0] : '';

  const creditValues = PARTNER_CREDIT_VALUES[partnerName] || [];
  const partnerLogo = isDesktop
    ? PARTNER_LOGO[partnerName]
    : PARTNER_MOBILE_LOGO[partnerName];

  const acceptedPaymentMethods: AcceptedPaymentMethods =
    ACCEPTED_PAYMENT_METHOD[partnerName] ??
    ACCEPTED_PAYMENT_METHOD[PARTNERS.DIRECT_SALES];

  const stateMachineConfig =
    PARTNER_MACHINES[partnerName] || directSalesMachineConfig;

  const ddMaxAttemps =
    AGENT_JOURNEYS_DIRECT_DEBIT_MAX_ATTEMPTS[partnerName] ||
    DIRECT_DEBIT_VERIFICATION_MAX_ATTEMPTS;

  return {
    partnerName,
    partnerPath,
    partnerLogo,
    activePartner,
    isDSJourney,
    isLidl,
    creditValues,
    acceptedPaymentMethods,
    stateMachineConfig,
    ddMaxAttemps
  };
};
